<template>
  <div class="sj_context_menu" :style="menuStyle">
    <SjMenu
      :data="menuData"
      :selectedKey="selectedKey"
      ref="menu"
      @select="handleMenuSelect"
      v-click-outside="destroyElement"
    />
  </div>
</template>

<script>
import Popup from "../../../utils/popup/index.js";
import vClickOutside from "v-click-outside";

export default {
  name: "SjDownload",
  mixins: [Popup],
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      event: null,
      menuData: null,
      onMenuSelect: null,
      selectedKey: [],
      menuStyle: {},
      closeOnSelect: true
    };
  },
  mounted() {
    const { event } = this;
    if (!event) {
      this.destroyElement();
      return;
    }
    event.preventDefault();
    this.$nextTick(() => {
      const rect = this.$refs.menu.$el.getBoundingClientRect();
      const { innerWidth, innerHeight } = window;
      const x = event.clientX;
      const y = event.clientY;
      const menuStyle = {
        top: y,
        left: x
      };
      console.log(x, rect.width, innerWidth);
      if (y + rect.height > innerHeight) {
        menuStyle.top -= rect.height;
      }

      if (x + rect.width > innerWidth) {
        menuStyle.left -= rect.width;
      }
      if (menuStyle.top < 0) {
        menuStyle.top =
          rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
      }

      if (menuStyle.left < 0) {
        menuStyle.left =
          rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
      }
      menuStyle.top += "px";
      menuStyle.left += "px";
      this.menuStyle = menuStyle;
    });
  },
  methods: {
    handleMenuSelect(...args) {
      if (this.onMenuSelect) {
        this.onMenuSelect(...args);
      }
      if (this.closeOnSelect) {
        this.destroyElement();
      }
    },
    destroyElement() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    destroy() {
      this.destroyElement();
    }
  }
};
</script>
<style lang="less">
.sj_context_menu {
  position: fixed;
}
</style>
